var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.textoExibido))]),_vm._v(" "),(_vm.textoUltrapassaouLimite)?_c('a',{staticClass:"cursor-pointer underline",on:{"click":_vm.handleLerMais}},[_vm._v("\n      "+_vm._s(_vm.textoBtn)+"\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }